import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("dh_admin_token", r.data.access_token);
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] grid place-items-center dh-container py-24">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md dh-card p-10 space-y-6">
        <div className="flex items-center gap-3">
          <Lock className="h-5 w-5 text-[color:hsl(var(--dh-terracotta))]" />
          <div className="dh-overline">{t.admin.login}</div>
        </div>
        <h1 className="font-serif text-4xl">Dar Hasna · Admin</h1>
        <div className="space-y-2">
          <Label className="dh-overline">{t.admin.email}</Label>
          <Input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-none bg-white border-[color:hsl(var(--dh-ocre)/0.4)]" />
        </div>
        <div className="space-y-2">
          <Label className="dh-overline">{t.admin.password}</Label>
          <Input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-none bg-white border-[color:hsl(var(--dh-ocre)/0.4)]" />
        </div>
        <button data-testid="login-submit" disabled={loading} className="dh-btn-primary w-full py-4">
          {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> …</> : t.admin.signIn}
        </button>
      </form>
    </div>
  );
}
